var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.32 18.16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66 0C2.86 0 0 3 0 6.52c0 4.94 4.33 9.49 6.29 11.32.2.19.36.32.36.32l.29-.27c2.21-1.99 6.37-6.3 6.37-11.38C13.32 3 10.46 0 6.66 0zm0 9.43c-1.39 0-2.52-1.16-2.52-2.6 0-1.43 1.13-2.6 2.52-2.6 1.39 0 2.52 1.16 2.52 2.6.01 1.44-1.12 2.6-2.52 2.6z"
  })));
};
export default SvgMarker;